import { ArrowUpRight, Gauge, Fuel, Settings2 } from "lucide-react";
import { motion } from "framer-motion";

const currency = new Intl.NumberFormat("nb-NO", { style: "currency", currency: "NOK", maximumFractionDigits: 0 });
const number = new Intl.NumberFormat("nb-NO");

export default function VehicleCard({ copy, vehicle, onOpen }) {
  const showVehicle = () => {
    if (vehicle.finn_link) {
      window.open(vehicle.finn_link, "_blank", "noopener,noreferrer");
      return;
    }
    onOpen(vehicle);
  };

  return (
    <motion.article className="vehicle-card" data-testid={`vehicle-card-${vehicle.id}`} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }}>
      <button className="vehicle-image-button" data-testid={`vehicle-open-${vehicle.id}`} onClick={showVehicle}>
        <img src={vehicle.main_image} alt={`${vehicle.brand} ${vehicle.model}`} data-testid={`vehicle-image-${vehicle.id}`} />
        <span className="vehicle-image-action">{vehicle.finn_link ? copy.vehicle_finn_label : copy.vehicle_details_label} <ArrowUpRight size={16} /></span>
      </button>
      <div className="vehicle-details">
        <div>
          <p className="vehicle-brand" data-testid={`vehicle-brand-${vehicle.id}`}>{vehicle.brand}</p>
          <h3 data-testid={`vehicle-name-${vehicle.id}`}>{vehicle.model} <span>{vehicle.variant}</span></h3>
        </div>
        <p className="vehicle-price" data-testid={`vehicle-price-${vehicle.id}`}>{currency.format(vehicle.price)}</p>
      </div>
      <div className="vehicle-specs" data-testid={`vehicle-specs-${vehicle.id}`}>
        <span><Gauge size={14} /> {number.format(vehicle.km)} km</span>
        <span><Fuel size={14} /> {vehicle.fuel}</span>
        <span><Settings2 size={14} /> {vehicle.transmission}</span>
        <span>{vehicle.year}</span>
      </div>
    </motion.article>
  );
}